<template>
    <div
        ref="tile-swiper"
        :class="[
            'tile-swiper-container',
            theme,
            pageLang,
            {
                pc: isPc
            }
        ]"
        :style="[cssProperties]"
    >
        <ul class="card-list">
            <li
                v-for="(item, index) in list"
                :key="index"
                :class="[
                    'card-item',
                    textType,
                    activeType,
                    {
                        active: activeIndex === index
                    }
                ]"
                @click="handleActive(index)"
            >
                <img class="icon" :src="item.icon" alt="" />
                <div class="text">
                    <template v-if="isLimitText">
                        <p class="title text-over limit-1" v-html="item.title"></p>
                        <p class="desc text-over limit-2" v-html="item.desc"></p>
                    </template>
                    <template v-else>
                        <p class="title" v-html="item.title"></p>
                        <CollapseTransition v-if="activeIndex === index">
                            <p class="desc" v-html="item.desc"></p>
                        </CollapseTransition>
                    </template>
                </div>
            </li>
        </ul>
        <div class="img-list" ref="swiper">
            <div class="swiper-wrapper">
                <div v-for="(item, i) in list" :key="i" class="swiper-slide">
                    <flow-container
                        v-if="swiperType === SWIPER_TYPE.VIDEO"
                        :children="children[i] ? [children[i]] : []"
                    />
                    <img v-else class="swiper-item" :src="item.img" alt="" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CONSTANT from '../common/constants';
const { SWIPER_TYPE, TEXT_OVERFLOW } = CONSTANT;
const {
    plugins: { ComplexComp }
} = require('@futuweb/fego-render') || require('@futuweb/fego-editor');
import { isEditor, isPc, getPageLang } from '../fego/utils';
import Swiper, { Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/autoplay';
const {
    rem: { rem }
} = require('@futuweb/fego-bridge');
import CollapseTransition from './CollapseTransition/index.vue';
export default {
    name: 'tile-swiper',
    components: {
        FlowContainer: ComplexComp.Container.Flow,
        CollapseTransition
    },
    props: {
        tpl: Object,
        // 类型
        textType: String,
        activeType: Boolean,
        // css 变量
        titleColor: String,
        descColor: String,
        bgColor: String,
        borderColor: String,
        titleActiveColor: String,
        descActiveColor: String,
        bgActiveColor: String,
        borderActiveColor: String,
        list: {
            type: Array,
            default: () => []
        },
        // 图片
        swiperWidth: {
            type: Number,
            default: 250
        },
        swiperHeight: {
            type: Number,
            default: 340
        },
        // 轮播
        loop: Boolean,
        autoPlay: Boolean,
        autoPlayDelay: {
            type: Number,
            default: 3000
        },
        // 暂不开放
        layoutSpace: {
            type: Number,
            default: 25
        },
        cardSpace: {
            type: Number,
            default: 20
        },
        cardHPadding: {
            type: Number,
            default: 15
        },
        swiperType: {
            type: String,
            default: SWIPER_TYPE.IMG
        },
        textLimit: {
            type: Number,
            default: TEXT_OVERFLOW.DEFAULT
        }
    },
    data() {
        return {
            isPc: isPc(),
            isEditor: isEditor(),
            pageLang: getPageLang(),
            SWIPER_TYPE,
            isPreRender: window.FEGORender?.common.env.isPreRender,
            activeIndex: 0
        };
    },
    computed: {
        cssProperties() {
            return {
                '--swiper-item-width': `${rem.str(this.swiperWidth)}`,
                '--swiper-item-height': `${rem.str(this.swiperHeight)}`,
                '--space-between': `${rem.str(this.layoutSpace)}`,
                '--card-space': `${rem.str(this.cardSpace)}`,
                '--card-h-padding': `${rem.str(this.cardHPadding)}`,
                '--editor-help-border': this.isEditor ? '1px dashed #e5e5e5' : 'none',
                '--card-border-color': this.borderColor,
                '--card-bg-color': this.bgColor,
                '--card-title-color': this.titleColor,
                '--card-desc-color': this.descColor,
                '--card-border-active-color': this.borderActiveColor,
                '--card-bg-active-color': this.bgActiveColor,
                '--card-title-active-color': this.titleActiveColor,
                '--card-desc-active-color': this.descActiveColor
            };
        },
        swiperOptions() {
            return {
                loop: this.loop,
                autoPlay: this.autoPlay,
                autoPlayDelay: this.autoPlayDelay,
                allowTouchMove: true
            };
        },
        children() {
            return (this.tpl.children || []).map((item) => {
                item.style.width = this.swiperWidth;
                item.style.height = this.swiperHeight;
                return item;
            });
        },
        isLimitText() {
            console.log('this.textLimit', this.textLimit);
            return this.textLimit === TEXT_OVERFLOW.DEFAULT || !this.textLimit;
        }
    },
    watch: {
        activeIndex(index) {
            if (index !== this.swiper?.realIndex) {
                this.swiper?.[this.loop ? 'slideToLoop' : 'slideTo'](index);
            }
        }
    },
    methods: {
        handleActive(index) {
            this.activeIndex = index;
        },
        initSwiper() {
            const $swiper = this.$refs['swiper'];
            this.swiper && this.swiper.destroy();
            const { loop, autoPlay, autoPlayDelay, allowTouchMove } = this.swiperOptions;
            this.swiper =
                this.list.length &&
                $swiper &&
                new Swiper($swiper, {
                    modules: [Autoplay],
                    initialSlide: this.activeIndex,
                    direction: 'vertical',
                    loop,
                    autoplay: autoPlay && {
                        delay: autoPlayDelay || 3000, // 每隔3秒自动播放
                        disableOnInteraction: false // 被用户交互之后，会继续自动播放
                    },
                    slidesPerView: 1,
                    autoHeight: true,
                    allowTouchMove,
                    on: {
                        slideChange: () => {
                            this.activeIndex = this.swiper.realIndex;
                        }
                    }
                });
        }
    },
    mounted() {
        !this.isPreRender && this.$nextTick(this.initSwiper);
    }
};
</script>
<style lang="less" scoped>
@import './variables.less';
.tile-swiper-container {
    height: auto !important;
    display: flex;
    align-items: center; //var(--flex-aligin-items);
    flex-direction: row;
    > .img-list {
        margin-left: var(--space-between);
    }
}
.img-list {
    width: var(--swiper-item-width);
    height: var(--swiper-item-height);
    overflow: hidden;
    .swiper-slide {
        width: var(--swiper-item-width);
        height: var(--swiper-item-height);
        border: var(--editor-help-border);
        overflow: hidden;
    }
    .swiper-item {
        width: 100%;
        height: auto;
    }
}
.card-list {
    flex: 1;
    border: var(--editor-help-border);
    .card-item {
        display: flex;
        align-items: center;
        cursor: pointer;
        background-color: var(--card-bg-color);
        border-radius: 0.1rem;
        + .card-item {
            margin-top: var(--card-space);
        }
        &.with-icon {
            .icon {
                display: block;
            }
        }
        .icon {
            display: none;
            margin-right: 0.2rem;
            width: 0.8rem;
            height: 0.8rem;
            border-radius: 0.1rem;
        }
        .text {
            flex: 1;
            .title {
                font-family: var(--card-title-font-family);
                font-size: var(--card-title-font-size);
                line-height: var(--card-title-line-height);
                color: var(--card-title-color);
            }
            .desc {
                font-family: var(--card-desc-font-family);
                font-size: var(--card-desc-font-size);
                line-height: var(--card-desc-line-height);
                color: var(--card-desc-color);
                margin-top: 0.14rem;
            }
        }
        &.text-active {
            padding: 0.3rem var(--card-h-padding);
            &.active {
                .title {
                    color: var(--card-title-active-color);
                }
                .desc {
                    color: var(--card-desc-active-color);
                }
            }
        }
        &.border-active {
            padding: 0.38rem var(--card-h-padding);
            border: 0.01rem solid var(--card-border-color);
            &.active {
                border-color: var(--card-border-active-color);
                background-color: var(--card-bg-active-color);
            }
        }
    }
}
.text-over {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    &.limit-1 {
        -webkit-line-clamp: 1;
    }
    &.limit-2 {
        -webkit-line-clamp: 2;
    }
}
</style>
